export default "__VITE_ASSET__CmqAcgzZ__"